import dayjs from "dayjs"

export const getDateString = (date?: string, withTime?: boolean) => {
    if (!date) return ""
    return dayjs(date)
        .format("DD.MM.YYYY" + (withTime ? " hh:mm" : ""))
}
